// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610261705/js/" + chunkId + "." + {"44":"cce480a6","225":"0e5d5895","481":"abb4ff50","486":"d72388b5","770":"9ef88b4f"}[chunkId] + ".0.4048538766889649.chunk.js";
};